import { mockData } from "./Mock";
import { Report } from "../../models/Report";

const mockUnprocessedReports: Report[] = [
    {
        id: 1,
        type: 0,
        reportTargetId: "P001",
        reportTargetName: "iPhone 15 Pro Max",
        reportReason: "商品描述与实际不符，存在虚假宣传",
        imageEvidences: ["https://example.com/evidence1.jpg", "https://example.com/evidence2.jpg"],
        processedDescript: "",
        status: 0,
        postTime: new Date("2024-03-15 10:30:00")
    },
    {
        id: 2,
        type: 1,
        reportTargetId: "S001",
        reportTargetName: "数码专营店",
        reportReason: "卖家态度恶劣，恶意拖延发货",
        imageEvidences: ["https://example.com/evidence3.jpg"],
        processedDescript: "",
        status: 0,
        postTime: new Date("2024-03-15 09:15:00")
    },
    {
        id: 3,
        type: 2,
        reportTargetId: "B001",
        reportTargetName: "购物达人小王",
        reportReason: "买家恶意差评，影响店铺评分",
        imageEvidences: ["https://example.com/evidence4.jpg", "https://example.com/evidence5.jpg"],
        processedDescript: "",
        status: 0,
        postTime: new Date("2024-03-15 08:45:00")
    }
];

const mockProcessedReports: Report[] = [
    {
        id: 4,
        type: 0,
        reportTargetId: "P002",
        reportTargetName: "华为Mate 60",
        reportReason: "商品质量问题，多次出现故障",
        imageEvidences: ["https://example.com/evidence6.jpg"],
        processedDescript: "已联系卖家下架商品，要求整改",
        status: 1,
        postTime: new Date("2024-03-14 16:20:00")
    },
    {
        id: 5,
        type: 1,
        reportTargetId: "S002",
        reportTargetName: "服装精品店",
        reportReason: "卖家虚假发货，物流信息造假",
        imageEvidences: ["https://example.com/evidence7.jpg"],
        processedDescript: "已对卖家进行警告，要求诚信经营",
        status: 1,
        postTime: new Date("2024-03-14 14:30:00")
    }
];

mockData.set("unprocessed_reports", mockUnprocessedReports);
mockData.set("processed_reports", mockProcessedReports); 